import { render, staticRenderFns } from "./view-renewal-payment.vue?vue&type=template&id=7145cf20&scoped=true"
import script from "./view-renewal-payment.vue?vue&type=script&lang=js"
export * from "./view-renewal-payment.vue?vue&type=script&lang=js"
import style0 from "./view-renewal-payment.vue?vue&type=style&index=0&id=7145cf20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145cf20",
  null
  
)

export default component.exports